import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeferredJsonMerger16i62uujz1qml as DeferredJsonMerger } from '../../internal/DeferredJsonMerger.mjs';
import {
  jsonReader2agwreccj3lmk as jsonReader,
  jsonReaderkr2c3w0efm9b as jsonReader_0,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import {
  toApolloResponse9u5mcqg84l2p as toApolloResponse,
  parseResponse2l74cu4whks78 as parseResponse,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { Token_NULL_getInstancepc9ujj0oty64 as Token_NULL_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReader.mjs';
import { readErrors1y0wtxnlur21l as readErrors } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/internal/ResponseParser.mjs';
import {
  RouterError3i6hxcnqsy5l3 as RouterError,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
  ApolloHttpException3o30u8ntkffuh as ApolloHttpException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  flowOf16f7h10nre075 as flowOf,
  flow3tazazxj2t7g4 as flow,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  multipartBodyFlow272n2l39kgnug as multipartBodyFlow,
  get_isGraphQLResponse3ogjhw8yzfes1 as get_isGraphQLResponse,
  get_isMultipart1je26zsopcnca as get_isMultipart,
} from '../../internal/multipart.mjs';
import { catchrcnx5mlu3pkp as catch_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { currentTimeMillis8vwamy6polhm as currentTimeMillis } from '../../../../../../apollo-kotlin-apollo-mpp-utils/com/apollographql/apollo/mpp/utils.mjs';
import { HttpInfo25xgxbxy3emkc as HttpInfo } from './HttpExecutionContext.mjs';
import {
  dispose2t7a37uqicel0 as dispose,
  HttpInterceptor2khzkwmar9lg6 as HttpInterceptor,
  DefaultHttpInterceptorChain22k3s5gesb9pu as DefaultHttpInterceptorChain,
} from './HttpInterceptor.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { DefaultHttpRequestComposer3cbqxfvy17yg2 as DefaultHttpRequestComposer } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
import { DefaultHttpEngine26xguluicr03l as DefaultHttpEngine } from './DefaultHttpEngine.js.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { emitAll14ajoawrvg9d0 as emitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpNetworkTransport$execute$slambda$o$collect$slambdaClass;
function HttpNetworkTransport$execute$slambda$o$collect$slambda() {
  if (HttpNetworkTransport$execute$slambda$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
        this.r68_1 = $$this$unsafeFlow;
        this.s68_1 = this$0;
        this.t68_1 = $request;
        this.u68_1 = $httpResponse;
        this.v68_1 = $millisStart;
      }
      *o1h(value, $completion) {
        var $this$transform = this.r68_1;
        var tmp$ret$1 = withHttpInfo(this.s68_1, value, this.t68_1.s42_1, this.u68_1, this.v68_1);
        yield* $this$transform.h1d(tmp$ret$1, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$execute$slambda$o$collect$slambdaClass = $;
  }
  return HttpNetworkTransport$execute$slambda$o$collect$slambdaClass;
}
function HttpNetworkTransport$execute$slambda$o$collect$slambda_0($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
  var i = new (HttpNetworkTransport$execute$slambda$o$collect$slambda())($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart);
  var l = (value, $completion) => i.o1h(value, $completion);
  l.$arity = 1;
  return l;
}
var HttpNetworkTransport$execute$2$$inlined$map$1Class;
function HttpNetworkTransport$execute$2$$inlined$map$1() {
  if (HttpNetworkTransport$execute$2$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, this$0, $request, $httpResponse, $millisStart) {
        this.w68_1 = $this;
        this.x68_1 = this$0;
        this.y68_1 = $request;
        this.z68_1 = $httpResponse;
        this.a69_1 = $millisStart;
      }
      *g1d(collector, $completion) {
        var tmp = HttpNetworkTransport$execute$slambda$o$collect$slambda_0(collector, this.x68_1, this.y68_1, this.z68_1, this.a69_1);
        yield* this.w68_1.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$execute$2$$inlined$map$1Class = $;
  }
  return HttpNetworkTransport$execute$2$$inlined$map$1Class;
}
var HttpNetworkTransport$multipleResponses$o$collect$slambdaClass;
function HttpNetworkTransport$multipleResponses$o$collect$slambda() {
  if (HttpNetworkTransport$multipleResponses$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger) {
        this.b69_1 = $$this$unsafeFlow;
        this.c69_1 = $operation;
        this.d69_1 = $customScalarAdapters;
        this.e69_1 = this$0;
        this.f69_1 = $jsonMerger;
      }
      *o1h(value, $completion) {
        var tmp0 = this.b69_1;
        $l$block: {
          var tmp;
          var tmp_0 = this.c69_1;
          if (isInterface(tmp_0, Subscription())) {
            var reader = jsonReader_0(value);
            var payloadResponse = null;
            var errors = null;
            reader.o40();
            while (reader.q1()) {
              switch (reader.q40()) {
                case 'payload':
                  if (reader.r3z().equals(Token_NULL_getInstance())) {
                    reader.q3z();
                  } else {
                    payloadResponse = parseResponse(reader, this.c69_1, VOID, this.d69_1, null);
                  }

                  break;
                case 'errors':
                  if (reader.r3z().equals(Token_NULL_getInstance())) {
                    reader.q3z();
                  } else {
                    errors = readErrors(reader);
                  }

                  break;
                default:
                  reader.q3z();
                  break;
              }
            }
            reader.p40();
            var tmp_1;
            if (!(errors == null)) {
              tmp_1 = errorResponse(this.e69_1, this.c69_1, RouterError().f4d(errors));
            } else if (!(payloadResponse == null)) {
              tmp_1 = payloadResponse;
            } else {
              tmp_1 = null;
            }
            tmp = tmp_1;
          } else {
            if (this.f69_1._v == null) {
              this.f69_1._v = new (DeferredJsonMerger())();
            }
            var merged = this.f69_1._v.y66(value);
            var deferredFragmentIds = this.f69_1._v.v66_1;
            var isLast = !this.f69_1._v.w66_1;
            var tmp_2;
            if (this.f69_1._v.x66_1) {
              tmp_2 = null;
            } else {
              tmp_2 = toApolloResponse(jsonReader(merged), this.c69_1, VOID, this.d69_1, deferredFragmentIds).e43().w43(isLast).y36();
            }
            tmp = tmp_2;
          }
          var tmp0_elvis_lhs = tmp;
          var tmp_3;
          if (tmp0_elvis_lhs == null) {
            break $l$block;
          } else {
            tmp_3 = tmp0_elvis_lhs;
          }
          var transformed = tmp_3;
          yield* tmp0.h1d(transformed, $completion);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$o$collect$slambdaClass = $;
  }
  return HttpNetworkTransport$multipleResponses$o$collect$slambdaClass;
}
function HttpNetworkTransport$multipleResponses$o$collect$slambda_0($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger) {
  var i = new (HttpNetworkTransport$multipleResponses$o$collect$slambda())($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger);
  var l = (value, $completion) => i.o1h(value, $completion);
  l.$arity = 1;
  return l;
}
function errorResponse($this, operation, throwable) {
  var tmp;
  if (throwable instanceof ApolloException()) {
    tmp = throwable;
  } else {
    tmp = ApolloNetworkException().c47('Error while reading JSON response', throwable);
  }
  var apolloException = tmp;
  var tmp0_requestUuid = uuid4();
  return Builder().p43(operation, tmp0_requestUuid).u43(apolloException).w43(true).y36();
}
function errorResponse_0($this, operation, httpResponse) {
  var tmp;
  if ($this.j69_1) {
    tmp = httpResponse.c49();
  } else {
    var tmp0_safe_receiver = httpResponse.c49();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.l6();
    }
    tmp = null;
  }
  var maybeBody = tmp;
  var apolloException = ApolloHttpException().z4c(httpResponse.y48_1, httpResponse.z48_1, maybeBody, 'Http request failed with status code `' + httpResponse.y48_1 + '`');
  return flowOf(errorResponse($this, operation, apolloException));
}
function singleResponse($this, operation, customScalarAdapters, httpResponse) {
  var response = toApolloResponse(jsonReader_0(ensureNotNull(httpResponse.c49())), operation, VOID, customScalarAdapters, null);
  return flowOf(response.e43().w43(true).y36());
}
function multipleResponses($this, operation, customScalarAdapters, httpResponse) {
  var jsonMerger = {_v: null};
  // Inline function 'kotlinx.coroutines.flow.mapNotNull' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = multipartBodyFlow(httpResponse);
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp = new (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1())(this_0, operation, customScalarAdapters, $this, jsonMerger);
  return catch_0(tmp, HttpNetworkTransport$multipleResponses$slambda_0(operation, $this));
}
function wrapIfNeeded($this, $receiver) {
  var tmp;
  if ($receiver instanceof ApolloException()) {
    tmp = $receiver;
  } else {
    tmp = ApolloNetworkException().c47('Error while reading response', $receiver);
  }
  return tmp;
}
function withHttpInfo($this, $receiver, requestUuid, httpResponse, millisStart) {
  // Inline function 'kotlin.apply' call
  var this_0 = $receiver.e43().e42(requestUuid);
  if (!(httpResponse == null)) {
    this_0.q43(new (HttpInfo())(millisStart, currentTimeMillis(), httpResponse.y48_1, httpResponse.z48_1));
  }
  return this_0.y36();
}
var EngineInterceptorClass;
function EngineInterceptor() {
  if (EngineInterceptorClass === VOID) {
    class $ {
      constructor($outer) {
        this.l69_1 = $outer;
      }
      *n68(request, chain, $completion) {
        return yield* this.l69_1.h69_1.i68(request, $completion);
      }
    }
    protoOf($).jz = dispose;
    initMetadataForClass($, 'EngineInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    EngineInterceptorClass = $;
  }
  return EngineInterceptorClass;
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.a65_1 = null;
        this.b65_1 = null;
        this.c65_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.d65_1 = ArrayList().p2();
        this.e65_1 = false;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.f65_1 = ArrayList().p2();
      }
      b64(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.b65_1 = serverUrl;
        return this;
      }
      h65(exposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.e65_1 = exposeErrorBody;
        return this;
      }
      g65(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.c65_1 = httpEngine;
        return this;
      }
      i65(interceptors) {
        // Inline function 'kotlin.apply' call
        this.d65_1.a5();
        this.d65_1.u2(interceptors);
        return this;
      }
      y36() {
        // Inline function 'kotlin.check' call
        if (!(this.a65_1 == null || this.b65_1 == null)) {
          var message = "It is an error to set both 'httpRequestComposer' and 'serverUrl'";
          throw IllegalStateException().o(toString(message));
        }
        var tmp0_elvis_lhs = this.a65_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.b65_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = new (DefaultHttpRequestComposer())(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp2_elvis_lhs = tmp;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message_0 = "No HttpRequestComposer found. Use 'httpRequestComposer' or 'serverUrl'";
          throw IllegalStateException().o(toString(message_0));
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var composer = tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.f65_1.n1()) {
          this.d65_1.i2(new (TransportHeadersInterceptor())(this.f65_1));
        }
        var tmp3_elvis_lhs = this.c65_1;
        return new (HttpNetworkTransport())(composer, tmp3_elvis_lhs == null ? DefaultHttpEngine() : tmp3_elvis_lhs, this.d65_1, this.e65_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var TransportHeadersInterceptorClass;
function TransportHeadersInterceptor() {
  if (TransportHeadersInterceptorClass === VOID) {
    class $ {
      constructor(headers) {
        this.m69_1 = headers;
      }
      *n68(request, chain, $completion) {
        return yield* chain.q68(request.j49().j48(this.m69_1).y36(), $completion);
      }
    }
    protoOf($).jz = dispose;
    initMetadataForClass($, 'TransportHeadersInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    TransportHeadersInterceptorClass = $;
  }
  return TransportHeadersInterceptorClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.n69_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.n69_1(value, $completion);
      }
      i5() {
        return this.n69_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
function sam$kotlinx_coroutines_flow_FlowCollector$0_0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.o69_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.o69_1(value, $completion);
      }
      i5() {
        return this.o69_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
}
var HttpNetworkTransport$execute$slambdaClass;
function HttpNetworkTransport$execute$slambda() {
  if (HttpNetworkTransport$execute$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $httpRequest, $request, $customScalarAdapters) {
        this.p69_1 = this$0;
        this.q69_1 = $httpRequest;
        this.r69_1 = $request;
        this.s69_1 = $customScalarAdapters;
      }
      *h66($this$flow, $completion) {
        var millisStart = currentTimeMillis();
        var throwable = null;
        var tmp;
        try {
          tmp = yield* (new (DefaultHttpInterceptorChain())(plus(this.p69_1.i69_1, this.p69_1.k69_1), 0)).q68(this.q69_1, $completion);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var t = $p;
            if (t instanceof CancellationException()) {
              throw t;
            }
            throwable = t;
            tmp_0 = null;
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        var httpResponse = tmp;
        var tmp_1;
        if (httpResponse == null) {
          tmp_1 = flowOf(errorResponse(this.p69_1, this.r69_1.r42_1, ensureNotNull(throwable)));
        } else {
          var tmp_2;
          var containsArg = httpResponse.y48_1;
          if (!(200 <= containsArg ? containsArg <= 299 : false)) {
            tmp_2 = !get_isGraphQLResponse(httpResponse);
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp_1 = errorResponse_0(this.p69_1, this.r69_1.r42_1, httpResponse);
          } else {
            if (get_isMultipart(httpResponse)) {
              tmp_1 = multipleResponses(this.p69_1, this.r69_1.r42_1, this.s69_1, httpResponse);
            } else {
              tmp_1 = singleResponse(this.p69_1, this.r69_1.r42_1, this.s69_1, httpResponse);
            }
          }
        }
        var responses = tmp_1;
        // Inline function 'kotlinx.coroutines.flow.map' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp$ret$0 = new (HttpNetworkTransport$execute$2$$inlined$map$1())(responses, this.p69_1, this.r69_1, httpResponse, millisStart);
        yield* emitAll($this$flow, tmp$ret$0, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.h66((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$execute$slambdaClass = $;
  }
  return HttpNetworkTransport$execute$slambdaClass;
}
function HttpNetworkTransport$execute$slambda_0(this$0, $httpRequest, $request, $customScalarAdapters) {
  var i = new (HttpNetworkTransport$execute$slambda())(this$0, $httpRequest, $request, $customScalarAdapters);
  var l = ($this$flow, $completion) => i.h66($this$flow, $completion);
  l.$arity = 1;
  return l;
}
var HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
function HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1() {
  if (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class === VOID) {
    class $ {
      constructor($this, $operation, $customScalarAdapters, this$0, $jsonMerger) {
        this.t69_1 = $this;
        this.u69_1 = $operation;
        this.v69_1 = $customScalarAdapters;
        this.w69_1 = this$0;
        this.x69_1 = $jsonMerger;
      }
      *g1d(collector, $completion) {
        var tmp = HttpNetworkTransport$multipleResponses$o$collect$slambda_0(collector, this.u69_1, this.v69_1, this.w69_1, this.x69_1);
        yield* this.t69_1.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0_0())(tmp), $completion);
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class = $;
  }
  return HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
}
var HttpNetworkTransport$multipleResponses$slambdaClass;
function HttpNetworkTransport$multipleResponses$slambda() {
  if (HttpNetworkTransport$multipleResponses$slambdaClass === VOID) {
    class $ {
      constructor($operation, this$0) {
        this.y69_1 = $operation;
        this.z69_1 = this$0;
      }
      *a6a($this$catch, throwable, $completion) {
        yield* $this$catch.h1d(Builder().p43(this.y69_1, uuid4()).u43(wrapIfNeeded(this.z69_1, throwable)).y36(), $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.a6a(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpNetworkTransport$multipleResponses$slambdaClass = $;
  }
  return HttpNetworkTransport$multipleResponses$slambdaClass;
}
function HttpNetworkTransport$multipleResponses$slambda_0($operation, this$0) {
  var i = new (HttpNetworkTransport$multipleResponses$slambda())($operation, this$0);
  var l = ($this$catch, throwable, $completion) => i.a6a($this$catch, throwable, $completion);
  l.$arity = 2;
  return l;
}
var HttpNetworkTransportClass;
function HttpNetworkTransport() {
  if (HttpNetworkTransportClass === VOID) {
    class $ {
      constructor(httpRequestComposer, engine, interceptors, exposeErrorBody) {
        this.g69_1 = httpRequestComposer;
        this.h69_1 = engine;
        this.i69_1 = interceptors;
        this.j69_1 = exposeErrorBody;
        this.k69_1 = new (EngineInterceptor())(this);
      }
      c66(request) {
        var customScalarAdapters = ensureNotNull(request.t42_1.a46(Key_getInstance()));
        var httpRequest = this.g69_1.b48(request);
        return this.b6a(request, httpRequest, customScalarAdapters);
      }
      b6a(request, httpRequest, customScalarAdapters) {
        return flow(HttpNetworkTransport$execute$slambda_0(this, httpRequest, request, customScalarAdapters));
      }
      jz() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.i69_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.jz();
        }
        this.h69_1.l6();
      }
    }
    initMetadataForClass($, 'HttpNetworkTransport');
    HttpNetworkTransportClass = $;
  }
  return HttpNetworkTransportClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_0 as Builder3d75eph7uovs3,
};
//endregion

//# sourceMappingURL=HttpNetworkTransport.mjs.map
